import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_system/_tenant')({
  head: () => ({
    meta: [{ title: 'Fleet Flow' }],
  }),
  component: Outlet,
  beforeLoad: () => {
    const { session } = useAuthSessionStore.getState();

    if (session?.organization?.company) {
      throw redirect({ to: '/' });
    }
  },
});
